export default "__VITE_ASSET__BXH6pgO7__"